module.exports = __webpack_public_path__ + "img/product_04.29e68a22.png";